const customImageInputStyle = (theme) => ({
  hidden: { display: 'none' },

  container: {
    display: 'flex',
    margin: 'auto',
  },
  title: {
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing.unit,
  },
  bigAvatar: {
    marginLeft: 20,
    width: 100,
    height: 100,
    borderColor: theme.palette.primary.main,
    borderStyle: 'solid',
    borderSize: '1px',
  },
  avatarThumb: {
    maxWidth: 100,
    maxHeight: 100,
  },
  primaryBack: {
    background: theme.palette.primary.main,
  },
  whiteBack: {
    background: 'white',
  },

  errorBack: { background: theme.palette.error.main },
});

export default customImageInputStyle;
